<template>
  <div class="footer">
    <div class="footer_content">
      <!-- <div class="footer_content-top">
        <div class="footer_content-top-left">友情链接</div>
        <div class="ol_lists">
          <ul>
            <li v-for="(item,index) in list" :key="index"><a :href="'http://'+item.link"  target="_blank">{{item.linkName}}</a></li>
          </ul>
        </div>
      </div> -->
      <div class="footer_content-bottom">
        <div class="footer_content-bottom-left">
          <ul>
            <li>{{companyInfo&&companyInfo.companyFullName}}</li>
            <li>电话：{{companyInfo&&companyInfo.phone}}</li>
            <!-- <li>Email：ting@hitalkers.com</li> -->
            <li>  
              <span>
                <!-- <a class="a_click" href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">粤ICP备19017293号</a> -->
                <a class="a_click" href="https://beian.miit.gov.cn/" target="_blank">{{companyInfo&&companyInfo.recordNumber}}</a>
              </span>
              <br>
            </li>
            <!-- <li>  <span><img class="wj" src="../assets/images/wj.png" alt="" ><a class="a_click" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009751" target="_blank" rel="nofollow">粤公网安备 44030502009751号</a></span><br></li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
    export default {
        name: "footerComponent",
        data(){
          return{
            list:[],
          }
        },
        computed: {
          ...mapState(['companyInfo'])
        },
        methods:{
          setData(){
            this.$axios.post('friendlyLink/all').then(res=>{
              if(res.data.code == 200 &&res.data.result){
                this.list = res.data.result
              }
              // console.log(this.list)s
            })
          }
        },
        created(){
          // this.setData()
        }
    }
</script>

<style scoped lang="less">
  .footer{
    width:100%;
    min-height:100px;
    background:#97574c;
    .footer_content{
      width: 1198px;
      height: 100%;
      margin: 0 auto;
      .footer_content-top{
        display: flex;
        min-height: 82px;
        border-bottom: 1px solid #E5E5E5;
        // background-color: #555882;
        .footer_content-top-left{
          // display: inline-block;
          width: 37px;
          height: 100%;
          // line-height: 40px;
          margin-right:55px;
          padding-top: 20px;
          box-sizing: border-box;
        }
        .ol_lists{
          // display: inline-block;
          flex: 1;
          height: 100%;
          // width: 1143px;
          ul{
            float: left;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            list-style: none;
            li{
              display: inline-block;
              width: 150px;
              margin-top: 12px;
              text-overflow: ellipsis;
              white-space:nowrap;
              overflow:hidden;
              margin-right: 10px;
              a{
                // color: #666666;
                font-size: 14px;
                color:rgba(102,102,102,1);
              }
              a:hover{
                color: blue;
              }
            }
          }
        }
      }
      .footer_content-bottom{
        width: 100%;
        min-height: 150px;
        margin-top: 19px;
        .footer_content-bottom-left{
          display: inline-block;
          overflow: hidden;
          img{
            margin-top: 31px;
            margin-right: 41px;
            width: 60px;
            height: 74px;
          }
            .wj{
            width: 20px;
            height: 20px;
            margin: 0;
            vertical-align: bottom;
          }
          ul{
            display: inline-block;
            vertical-align: top;
            margin:31px;
            padding: 0;
            list-style: none;
            li{
              margin-bottom: 5px;
              font-size: 14px;
              // color: #999999;
              color: #fff;
            }
          }
        }
        .footer_content-bottom-right{
          box-sizing: border-box;
          padding-top:10px ;
          margin-top: 19px;
          float:right;
          width: 259px;
          height: 131px;
          text-align: center;
          // background-color: #fff;
          img{
            display: block;
            margin-top: 5px;
            width: 100%;
            // height: 87px;
            margin: 0 auto;
          }
        
          span{
            color: #666666;
            font-size: 14px
          }
        }
      }
    }
  }
  .a_click{
    color: #fff;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/footerComponent.vue